/**
 * @file move-to-pending-span.tsx
 * @module app/modules/_common/components/move-to-pending-span
 * @description Reusable component to display reprocessable order status icon with tooltip.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.0
 * @version 1.3.0
 */

import { OverlayTrigger, Popover } from 'react-bootstrap';
import { MoveToPendingMsg } from '../../../../utils/common.constants';
import statusCircleIcon from '../../../../_admin/assets/media/svg_uTrade/contract-pending.svg';

interface MoveToPendingSpanProps {
  className?: string;
  msg?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

export const MoveToPendingSpan: React.FC<MoveToPendingSpanProps> = ({ className = 'ms-2', msg = '', placement = 'top' }) => {
  return (
    <span
      className={`${className} border border-light rounded p-2 release-highlighter--move-to-pending`}
    >
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement={placement}
        overlay={
          <Popover className="bg-dark">
            <Popover.Body className="text-white fw-500 py-2 px-3">
              {MoveToPendingMsg + ' ' + msg}
            </Popover.Body>
          </Popover>
        }
      >
        <img
          width={20}
          height={20}
          src={statusCircleIcon}
          alt="Status Info"
          className="cursor-pointer"
        />
      </OverlayTrigger>
    </span>
  );
};

export default MoveToPendingSpan;
